export default __webpack_public_path__ + "static/media/3031 spice rack D side.5e3b893f.png";